import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';
import { SelfOnboardingActor } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.actor}selfonboarding/actor`;

interface GetSelfOnboardingActorsQueryResponse extends BaseBackResponse {
  value: SelfOnboardingActor[];
}

interface DeleteSelfOnboardingActorCommandPayload {
  sellerId?: string;
  actorSolutionRuleId?: string;
}

async function deleteSelfOnboardingActorCommand({
  sellerId,
  actorSolutionRuleId,
}: DeleteSelfOnboardingActorCommandPayload): Promise<
  GetSelfOnboardingActorsQueryResponse | BackResponseFailure
> {
  try {
    const response = await apiCall<GetSelfOnboardingActorsQueryResponse>(
      ENDPOINT,
      {
        method: SUPPORTED_METHODS.DELETE,
        json: {
          sellerId,
          actorSolutionRuleId,
        },
      },
    );

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default deleteSelfOnboardingActorCommand;
